'use client';

import { useScroll } from 'framer-motion';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import MainLayout from 'src/layouts/main';

import ScrollProgress from 'src/components/scroll-progress';

import HomeHero from '../home-hero';
import HomeSkills from '../home-skill';
import HomeContactCTA from '../home-contact-cta';
import HomeContentCTA from '../home-content-cta';
import HomeCompaniesDark from '../home-dark-mode';
import HomeForDesigner from '../home-for-designer';
import HomeCapabilities from '../home-capabilities';
import HomeExperienceStats from '../HomeExperienceStats';

// ----------------------------------------------------------------------

const StyledPolygon = styled('div')(({ anchor = 'top', theme }) => ({
  left: 0,
  zIndex: 9,
  height: 80,
  width: '100%',
  position: 'absolute',
  clipPath: 'polygon(0% 0%, 100% 100%, 0% 100%)',
  backgroundColor: theme.palette.background.default,
  display: 'block',
  lineHeight: 0,
  ...(anchor === 'top' && {
    top: -1,
    transform: 'scale(-1, -1)',
  }),
  ...(anchor === 'bottom' && {
    bottom: -1,
    backgroundColor: theme.palette.grey[900],
  }),
}));

// ----------------------------------------------------------------------

export default function HomeView() {
  const { scrollYProgress } = useScroll();

  return (
    <MainLayout>
      <ScrollProgress scrollYProgress={scrollYProgress} />
      <HomeHero />
      <Box sx={{ position: 'relative', bgcolor: 'background.default' }}>
        <HomeCapabilities />
        <HomeExperienceStats />
        <HomeSkills />

        <Box sx={{ position: 'relative' }}>
          <StyledPolygon />
          <HomeForDesigner />
          <StyledPolygon anchor="bottom" />
        </Box>
        <HomeCompaniesDark />
        <HomeContactCTA />
        <HomeContentCTA />
      </Box>
    </MainLayout>
  );
}
